import { render, staticRenderFns } from "./Questions.vue?vue&type=template&id=afc4326e&scoped=true"
import script from "./Questions.vue?vue&type=script&lang=js"
export * from "./Questions.vue?vue&type=script&lang=js"
import style0 from "./Questions.vue?vue&type=style&index=0&id=afc4326e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc4326e",
  null
  
)

export default component.exports